import { reactive } from 'vue'
import type { Application, ApplicationStatus, ApplicationPlatform } from '@/types'

export interface ApplicationsState {
  applications: Application[]
  selectedApplication: Application | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    projectId: string
    status: ApplicationStatus | ''
    platform: ApplicationPlatform | ''
  }
}

export const getInitialState = (): ApplicationsState => ({
  applications: [],
  selectedApplication: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    projectId: '',
    status: '',
    platform: '',
  },
})

export const createState = (): ApplicationsState => {
  return reactive(getInitialState())
}

export const resetState = (state: ApplicationsState): void => {
  const initial = getInitialState()
  state.applications = initial.applications
  state.selectedApplication = initial.selectedApplication
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
